import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function TheFifthClimate() {
  const raindrops = Array.from({ length: 200 });
  const assets = useAssets();
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // or behavior: "auto"
      }
    }
  }, [location]);
  return (
    <div>
      <div className="inner-new-section-1 climate-bg-1 ">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500">
            <h1 className="white-color" data-aos="fade-up">
              Voices From the Edge of Climate, Intelligence, and Imagination
            </h1>
            <p data-aos="zoom-in">
              Where regenerative futures meet radical ideas.
            </p>
            <p data-aos="zoom-in">
              From ecosystem hackers and AI ethicists to planetary designers and
              grassroots stewards, our podcast dives deep into the untold
              stories shaping the climate-human-technology frontier.
            </p>
          </div>
          <div className=" padding-bottom-2">
            <div className="text-left" data-aos="fade-down">
              <Link
                to="/TheFifthClimate#VideoSec"
                className="button-1 green-bg"
              >
                Explore Episodes
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="climate-bg-2">
        <div className="climate-sec-main">
          <div className="climate-sec-1">
            <img
              src={assets.SaiBhaskarReddy3}
              alt="SaiBhaskarReddy3"
              className="d-d"
            />
            <img
              src={assets.SaiBhaskarReddy4}
              alt="SaiBhaskarReddy2"
              className="m-d"
            />
          </div>
          <div className="climate-sec-2">
            <h5>
              “Storytelling isn’t about broadcasting—it’s about belonging. And
              the climate needs voices that belong to the future.”
            </h5>
            <h6>— Pratibha Chauhan</h6>
          </div>
        </div>
      </div>
      {/* <div className="bg-section-1 green-bg-2">
        <div className="wrapper">
          <h2 data-aos="zoom-in" className="text-center green-color">
            What’s Coming
          </h2>
          <div className="pledge-wrap hydro-ul">
            <div className="pledge-line"></div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.wc1} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>1. On-the-ground Reporting</h4>
                <p>
                  Straight from solar fields, salt mines, and hydro farms.
                  She’ll capture the voices of farmers, engineers, and
                  eco-warriors reshaping our planet.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.wc2} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>2. Podcasts with Climate Mavericks</h4>
                <p>
                  Global thought leaders and grassroots heroes. Expect
                  cross-continental conversations that break silos and spark
                  change.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.wc3} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>3. Viral-Ready Reels & Shorts</h4>
                <p>
                  Climate storytelling—Gen Z style. On Instagram, YouTube
                  Shorts, and TikTok, where the next generation actually
                  listens.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.wc4} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>4. Brand New Energy</h4>
                <p>
                  From poetic climate diaries to interactive map
                  journeys—Pratibha brings a bold, experimental spirit to
                  Sustainability and Social Empowerment storytelling.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="">
        <div className="fifthclimate-sec2-wrap">
          <div className="fifthclimate-sec2-main">
            <div className="fifthclimate-sec2-1">
              <img src={assets.wc1_1} alt="" data-aos="zoom-in" />
            </div>
            <div className="fifthclimate-sec2-2">
              <h4>1. On-the-ground Reporting</h4>
              <p>
                Straight from solar fields, salt mines, and hydro farms. She’ll
                capture the voices of farmers, engineers, and eco-warriors
                reshaping our planet.
              </p>
            </div>
          </div>
          <div className="fifthclimate-sec2-main">
            <div className="fifthclimate-sec2-1">
              <img src={assets.wc2_1} alt="" data-aos="zoom-in" />
            </div>
            <div className="fifthclimate-sec2-2">
              <h4>2. Podcasts with Climate Mavericks</h4>
              <p>
                Global thought leaders and grassroots heroes. Expect
                cross-continental conversations that break silos and spark
                change.
              </p>
            </div>
          </div>
          <div className="fifthclimate-sec2-main">
            <div className="fifthclimate-sec2-1">
              <img src={assets.wc3_1} alt="" data-aos="zoom-in" />
            </div>
            <div className="fifthclimate-sec2-2">
              <h4>3. Viral-Ready Reels & Shorts</h4>
              <p>
                Climate storytelling—Gen Z style. On Instagram, YouTube Shorts,
                and TikTok, where the next generation actually listens.
              </p>
            </div>
          </div>
          <div className="fifthclimate-sec2-main">
            <div className="fifthclimate-sec2-1">
              <img src={assets.wc4_1} alt="" data-aos="zoom-in" />
            </div>
            <div className="fifthclimate-sec2-2">
              <h4>4. Brand New Energy</h4>
              <p>
                From poetic climate diaries to interactive map journeys—Pratibha
                brings a bold, experimental spirit to Sustainability and Social
                Empowerment storytelling.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="climate-bg-3" id="VideoSec">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Podcasts</h2>
            <div className="podcast-video">
              <iframe
                width="100%"
                height="505"
                src="https://www.youtube.com/embed/IlnRmWWV-BE?si=q9iNftn94MU9piWl"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="section-1" style={sectionStyle}>
        <img src={assets.banner1} alt="" data-aos="fade-up" />
      </div> */}
    </div>
  );
}

export default TheFifthClimate;
